import { Box, Pressable, Text } from "components/ui";
import React from "react";

interface AddressPredictionsProps {
	predictions: any[];
	onSelect: (prediction: any) => void;
}

export default function AddressPredictions({ predictions, onSelect }: AddressPredictionsProps) {
	if (!predictions?.length) {
		return null;
	}

	return (
		<Box position="absolute" top="100%" left={0} right={0} backgroundColor="$white" borderRadius={8} borderWidth={1} borderColor="$neutral100" zIndex={1000} maxHeight={200} overflow="scroll">
			{predictions.map((prediction, index) => (
				<Pressable key={prediction.place_id} onPress={() => onSelect(prediction)} padding={12} backgroundColor={index % 2 === 0 ? "$white" : "$neutral50"}>
					<Text>{prediction.description}</Text>
				</Pressable>
			))}
		</Box>
	);
}
